var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfRoomEquip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,32.5c-0.3-1.6-1.9-2.7-3.5-2.4c-1.2,0.2-2.2,1.2-2.4,2.4c-0.4-0.1-0.7-0.1-1.1,0 c-0.3-1.6-1.9-2.7-3.5-2.4c-1.2,0.2-2.2,1.2-2.4,2.4c-0.4-0.1-0.7-0.1-1.1,0c-0.2-1.5-1.4-2.6-2.9-2.6c-1.5,0-2.8,1.1-3,2.6 c-0.8-0.2-1.7,0.1-2.4,0.6c-0.7,0.6-1.1,1.4-1.1,2.3V37c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5v-1.5c0-0.2,0-0.3-0.1-0.5 H16v2c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5v-1.5c0-0.2-0.1-0.3-0.1-0.5H23v2c0,0.3,0.2,0.5,0.5,0.5h4.9 c0.3,0,0.5-0.2,0.5-0.5v-2H30c0,0.2-0.1,0.3-0.1,0.5V37c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5v-1.5c0-0.9-0.4-1.7-1-2.3 C34.2,32.6,33.3,32.4,32.5,32.5z M29.5,31c1.1,0,1.9,0.8,2,1.9L30.3,34h-1.8c-0.3-0.4-0.6-0.8-1-1.1C27.6,31.8,28.4,31,29.5,31z  M22.5,31c1,0.1,1.8,0.9,1.9,1.9c-0.4,0.3-0.7,0.7-1,1.1h-1.8c-0.3-0.4-0.7-0.8-1.1-1.1C20.6,31.8,21.5,30.9,22.5,31z M15.5,31 c1,0,1.9,0.9,2,1.9c-0.5,0.3-0.8,0.6-1.1,1.1h-1.8l-1.1-1.1C13.6,31.8,14.5,30.9,15.5,31z M14,36.5h-4v-1c0-1.1,0.9-2,2-2 s2,0.9,2,2V36.5z M21,36.5h-4v-1c0-1.1,0.9-2,2-2s2,0.9,2,2V36.5z M28,35.5v1H24v-1c-0.1-1,0.7-1.9,1.8-2c0.1,0,0.1,0,0.2,0 c1,0,1.9,0.8,1.9,1.9C28,35.4,28,35.4,28,35.5z M35,35.5v1h-4v-1c0-1.1,0.9-2,2-2C34.1,33.5,35,34.3,35,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M33,33.5c-1.1,0-2,0.9-2,2v1h4v-1C35,34.3,34.1,33.5,33,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M12,33.5c-1.1,0-2,0.9-2,2v1h4v-1C14,34.3,13.2,33.5,12,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.5,34c0.3-0.5,0.6-0.8,1.1-1.1c-0.1-1-1-1.9-2-1.9c-1.1,0-1.9,0.8-2,1.9l1.1,1.1H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19,33.5c-1.1,0-2,0.9-2,2v1h4v-1C21,34.3,20.2,33.5,19,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M20.5,32.9c0.4,0.3,0.8,0.7,1.1,1.1h1.8c0.3-0.4,0.6-0.8,1-1.1c-0.1-1-0.9-1.8-1.9-1.9 C21.5,30.9,20.6,31.8,20.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M26,33.5c-0.1,0-0.1,0-0.2,0c-1,0.1-1.9,1-1.8,2v1H28v-1c0,0,0-0.1,0-0.1C28,34.3,27.1,33.4,26,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M27.5,32.9c0.4,0.3,0.7,0.7,1,1.1h1.8l1.1-1.1c-0.1-1.1-0.9-1.9-2-1.9C28.4,31,27.6,31.8,27.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37,7.5H8C7.8,7.5,7.5,7.8,7.5,8v2c0,0.3,0.2,0.5,0.5,0.5h1V24c0,0.3,0.2,0.5,0.5,0.5h2.6h6.6L19,26h-0.4 c-0.2,0-0.5,0.2-0.5,0.4v2c0,0.3,0.2,0.5,0.5,0.5h7.9c0.3,0,0.5-0.2,0.5-0.5v-2c0-0.2-0.3-0.4-0.5-0.4H26l0.3-1.5h6.5h2.6 c0.3,0,0.5-0.2,0.5-0.5V10.5h1c0.3,0,0.5-0.2,0.5-0.5V8C37.5,7.8,37.2,7.5,37,7.5z M26,28h-7v-1h7V28z M25,26H20l-0.8-5.5H26L25,26 z M17.1,18.5h10.7l-0.2,1h-2.1h-6h-2.1L17.1,18.5z M35,23.5h-8.5l0.5-3h1c0.2,0,0.5-0.2,0.5-0.4l0.5-2c0.1-0.2,0-0.3-0.1-0.4 c-0.1-0.1-0.2-0.2-0.4-0.2h-1V16c0-0.2,0-0.3-0.1-0.4l-1-1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.8-0.6-1.4-1.4-1.5c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5l0.6-0.2l0.8,0.9v1.3h-7.9v-1.3l0.8-0.9l0.7,0.2c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5 c0,0.2,0,0.4,0.1,0.6l-1,1c-0.1,0.1-0.1,0.2-0.1,0.4v1.5h-1c-0.2,0-0.3,0-0.4,0.2C16,18,16,18,16,18.2l0.5,2c0,0.2,0.3,0.4,0.5,0.4 h1l0.5,3H10v-13H35V23.5z M24.5,14c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5S24.5,14.3,24.5,14z M20,13.5 c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5C19.5,13.8,19.8,13.5,20,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26,20.5h-6.8L20,26H25L26,20.5z M22,21.5h1v1h-1V21.5z M21,24.5v-1h3v1H21z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21.5,
    fill: "#505050",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23.5,
    fill: "#505050",
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "25.5,19.5 27.6,19.5 27.8,18.5 17.1,18.5 17.5,19.5 19.5,19.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    fill: "#C9C9C9",
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A1A1",
    cx: 25,
    cy: 14,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A1A1",
    cx: 20,
    cy: 14,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10,10.5v13h8.5l-0.5-3h-1c-0.2,0-0.5-0.2-0.5-0.4l-0.5-2c0-0.2,0-0.2,0.1-0.4c0.1-0.2,0.2-0.2,0.4-0.2h1 V16c0-0.2,0-0.3,0.1-0.4l1-1c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5l-0.7-0.2l-0.8,0.9 v1.3h7.9v-1.3l-0.8-0.9L25,15.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c0.8,0.1,1.4,0.7,1.4,1.5c0,0.2,0,0.4-0.1,0.6l1,1 c0.1,0.1,0.1,0.2,0.1,0.4v1.5h1c0.2,0,0.3,0.1,0.4,0.2C29,17.9,29,18,29,18.2l-0.5,2c0,0.2-0.3,0.4-0.5,0.4h-1l-0.5,3H35v-13H10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfRoomEquip);
export default __webpack_public_path__ + "static/media/conf_room_equip.0eaf8a36ab7fb05c6bbd6f37f993b4ac.svg";
export { ForwardRef as ReactComponent };